var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { makeUniqueArray } from '../../../../utils/make-unique-array';
import { getAdditionalRoutes, getRoutesWithoutCompleteConfig, getRoutesWithoutInlinedConfig, } from './get-routes';
export var getFilteredMenuList = function (_a) {
    var flattenMenuProductsList = _a.flattenMenuProductsList, additionalProductsData = _a.additionalProductsData, routeUrl = _a.routeUrl, excludeEndpoinds = _a.excludeEndpoinds, currentRoute = _a.currentRoute;
    var additionalRoutes = getAdditionalRoutes({
        additionalProductsData: additionalProductsData,
        flattenMenuProductsList: flattenMenuProductsList,
    });
    console.log('[fetchProductsWorkerSaga]: additionalRoutes', additionalRoutes);
    // check if route is system and not loaded as usual products
    var isRouteExcluded = excludeEndpoinds
        ? Boolean(excludeEndpoinds.find(function (routePath) { return routePath === routeUrl; }))
        : false;
    console.log('[fetchProductsWorkerSaga]: isRouteExcluded', isRouteExcluded);
    if (isRouteExcluded) {
        return additionalRoutes;
    }
    // if no current route found - return all routes as a fallback
    if (!currentRoute || !currentRoute.staticURL) {
        console.log('[fetchProductsWorkerSaga]: no current route - try to fetch all routes without config');
        // fallback for buggy routes
        var routesWithoutInlinedConfig = getRoutesWithoutInlinedConfig(flattenMenuProductsList);
        console.log('[fetchProductsWorkerSaga]: routesWithoutInlinedConfig', routesWithoutInlinedConfig);
        var routesWithoutCompleteConfig = getRoutesWithoutCompleteConfig(flattenMenuProductsList);
        var resultRoutes_1 = makeUniqueArray({
            array: __spreadArray(__spreadArray(__spreadArray([], additionalRoutes, true), routesWithoutInlinedConfig, true), routesWithoutCompleteConfig, true),
            fieldName: 'staticURL',
        });
        return resultRoutes_1;
    }
    var resultRoutes = makeUniqueArray({
        array: __spreadArray(__spreadArray([], additionalRoutes, true), [currentRoute], false),
        fieldName: 'staticURL',
    });
    return resultRoutes;
};
